import { loadView } from '@/router'

export default [
  {
    path: 'pickups',
    name: 'customerservice-pickups',
    component: loadView('Application/CustomerService/Pickups'),
    redirect: {
      name: 'customerservice-pickups-list'
    },
    showInAlfred: true,
    alfredTitle: 'Customer Service - Pickups',
    children: [
      {
        path: 'list',
        name: 'customerservice-pickups-list',
        component: loadView('Application/CustomerService/Pickups/List')
      },
      {
        path: ':pickupId',
        name: 'customerservice-pickups-pickup',
        component: loadView('Application/CustomerService/Pickups/Pickup'),
        redirect: {
          name: 'customerservice-pickups-pickup-details'
        },
        children: [
          {
            path: 'details',
            name: 'customerservice-pickups-pickup-details',
            component: loadView('Application/CustomerService/Pickups/Pickup/Details')
          },
          {
            path: 'notes',
            name: 'customerservice-pickups-pickup-notes',
            component: loadView('Application/CustomerService/Pickups/Pickup/Notes')
          },
          {
            path: 'history',
            name: 'customerservice-pickups-pickup-history',
            component: loadView('Application/CustomerService/Pickups/Pickup/History')
          }
        ]
      }
    ]
  }
]
